import React, { useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../CartContext';
import axios from 'axios';

const Cart = () => {
  const navigate = useNavigate();
  const { cart, removeFromCart, updateCartItem, setCart } = useContext(CartContext);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // 檢查是否登入
  useEffect(() => {
    const token = localStorage.getItem('token');
    document.title = '購物車';
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const handleQuantityChange = (productId, size, member, newQuantity) => {
    updateCartItem(productId, size, member, parseInt(newQuantity, 10));
  };

  const handleRemove = (productId, size, member) => {
    removeFromCart(productId, size, member);
  };

  const handleSubmitOrder = async () => {
    const userId = localStorage.getItem('userId');  // 獲取用戶ID
    const token = localStorage.getItem('token');  // 獲取token

    if (!userId) {
      setErrorMessage('用戶未登入');
      return;
    }

    try {
      const order = {
        userId,  // 使用實際的用戶ID
        products: cart.map((item) => ({
          productId: item.productId,
          quantity: item.quantity,
          size: item.size,
          member: item.member,
        })),
        totalAmount: cart.reduce((total, item) => total + item.price * item.quantity, 0),
      };

      const response = await axios.post('https://shopapi.nogi46.me/api/orders', order, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setCart([]);
      setSuccessMessage(`訂單提交成功！訂單編號：${response.data.orderNumber}`);
      setErrorMessage('');
    } catch (error) {
      console.error(error);
      setErrorMessage('提交訂單失敗，請稍後再試。');
      setSuccessMessage('');
    }
  };

  return (
    <Container>
      <h1>購物車</h1>
      {successMessage && <Alert variant="success">{successMessage}</Alert>}
      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
      {cart.length === 0 ? (
        <p>購物車是空的</p>
      ) : (
        <>
          <Row>
            {cart.map((item) => (
              <Col key={`${item.productId}-${item.size}-${item.member}`} xs={12} className="mb-3">
                <Row>
                  <Col md={4}>
                    <img src={item.image} alt={item.name} style={{ width: '100%' }} />
                  </Col>
                  <Col md={8}>
                    <h4>{item.name}</h4>
                    <p>價格: ${item.price}</p>
                    {item.size && <p>大小: {item.size}</p>}
                    {item.member && <p>成員: {item.member}</p>}
                    <Form.Group controlId={`quantity-${item.productId}-${item.size}-${item.member}`}>
                      <Form.Label>數量</Form.Label>
                      <Form.Control
                        type="number"
                        value={item.quantity}
                        onChange={(e) => handleQuantityChange(item.productId, item.size, item.member, e.target.value)}
                        min="1"
                      />
                    </Form.Group>
                    <Button variant="danger" onClick={() => handleRemove(item.productId, item.size, item.member)} className="mt-3">
                      移除
                    </Button>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
          <Button variant="primary" onClick={handleSubmitOrder} className="mt-3">提交訂單</Button>
        </>
      )}
    </Container>
  );
};

export default Cart;
